import React, {useEffect, useRef, useState} from "react";
import {IStepAudible} from "../../interfaces/IStepAudible";
import {CardActionArea} from "@material-ui/core";
import AscendAudioPlayer from "../v2/ascendaudioplayer";



function Audible(props: IStepAudible){

    const [open, setOpen] = React.useState(false);
    const [donePlaying, setFinishedPlaying] = React.useState(false);
    const divRef = useRef<HTMLDivElement>(null);
    const [isAtBottom, setIsAtBottom] = useState(false);

    useEffect(() => {
        const divElement = divRef.current;

        const handleScroll = () => {
            if (divElement &&
                divElement.scrollTop + divElement.clientHeight >=
                divElement.scrollHeight
            ) {
                setIsAtBottom(true);
            } else {
                setIsAtBottom(false);
            }
        };

        if (divElement) {
            divElement.addEventListener('scroll', handleScroll);
            return () => {
                divElement.removeEventListener('scroll', handleScroll);
            };
        }
    }, []);

    const AudioModal = () => {
        return (
            (open) ?
                <div className={'modal'}>
                    <div className={'modal-container'}>
                        <p>
                            It looks like you haven't finished reading or listened to this task yet.
                            This stuff is important to understand for recovery.
                        </p>
                        <div className={"action-area"}>
                            <CardActionArea className={'button'} onClick={props.moveNext}>Continue Anyway</CardActionArea>
                            <CardActionArea className={'button'}
                            onClick={()=> {setOpen(false)}}>I'll finish reading / listening</CardActionArea>
                        </div>
                    </div>
                </div> : ''
        )
    }

    return(
        <>
            <AudioModal/>
            <div className={'audible'}>
                <div className={'header'}>
                    <div className={'header-content'}>
                        <div className={'topic'}>TOPIC</div>
                        <div className={'title'}>
                            {props.header}
                        </div>
                    </div>
                </div>
                <div className={'media-container'}>
                    <div className={'player'}>
                        <AscendAudioPlayer
                            src={props.audioUrl}
                            onFinished={()=> {
                                setFinishedPlaying(true)
                            }}
                        />
                    </div>
                </div>

                <div className={'transcript-container'} ref={divRef}>
                    <div className={'transcript-content'}>
                        <div className={'label-transcript'}>TRANSCRIPT</div>
                        <div className={'transcript-text'} dangerouslySetInnerHTML={{__html: props.transcript}}/>
                        <div className={'transcript-action-space'}/>
                        <div className={'transcript-action-area'}>
                            <div className={'gradient-cover'}/>
                            <CardActionArea className={'transcript-previous-button'} onClick={props.moveBack}>
                                Previous
                            </CardActionArea>
                            <CardActionArea className={'transcript-button'} onClick={() => {
                                if(isAtBottom || donePlaying) {
                                    props.moveNext()
                                } else {
                                    setOpen(true)
                                }
                            }}>
                                {/*{(props.buttonLabel) ? props.buttonLabel : "Next"}*/}
                                Next
                            </CardActionArea>
                        </div>
                        <div className={'transcript-action-space'}/>
                    </div>
                </div>
            </div>
        </>

    )
}

export default Audible;